import { useEffect, useState } from 'react';

export type AppRoutePath =
  | '/'
  | '/login'
  | '/company-select'
  | '/diagnostics/code128'
  | '/home'
  | '/my-holding'
  | '/pmi-continuous'
  | '/pmi-history'
  | '/pmi-group'
  | '/pmi-scan'
  | '/tasks'
  | '/scan/delivery-pallet-bind'
  | '/scan/label-verification'
  | '/scan/pmi-rebind'
  | '/scan/inbound'
  | '/scan/pre-inbound'
  | '/scan/outbound'
  | '/scan/transfer'
  | '/trace'
  | '/trace/raw-material';

const knownRoutePaths: Record<AppRoutePath, true> = {
  '/': true,
  '/company-select': true,
  '/diagnostics/code128': true,
  '/home': true,
  '/login': true,
  '/my-holding': true,
  '/pmi-continuous': true,
  '/pmi-history': true,
  '/pmi-group': true,
  '/pmi-scan': true,
  '/scan/delivery-pallet-bind': true,
  '/scan/label-verification': true,
  '/scan/pmi-rebind': true,
  '/tasks': true,
  '/scan/inbound': true,
  '/scan/pre-inbound': true,
  '/scan/outbound': true,
  '/scan/transfer': true,
  '/trace': true,
  '/trace/raw-material': true,
};

export const protectedRoutePaths: Partial<Record<AppRoutePath, true>> = {
  '/company-select': true,
  '/home': true,
  '/my-holding': true,
  '/pmi-continuous': true,
  '/pmi-history': true,
  '/pmi-group': true,
  '/pmi-scan': true,
  '/scan/delivery-pallet-bind': true,
  '/scan/label-verification': true,
  '/scan/pmi-rebind': true,
  '/tasks': true,
  '/scan/inbound': true,
  '/scan/pre-inbound': true,
  '/scan/outbound': true,
  '/scan/transfer': true,
  '/trace': true,
  '/trace/raw-material': true,
};

export function getHashPath(): AppRoutePath {
  const rawHash = window.location.hash.replace(/^#/, '') || '/';
  return knownRoutePaths[rawHash as AppRoutePath] ? (rawHash as AppRoutePath) : '/';
}

export function navigateTo(path: AppRoutePath, replace?: boolean) {
  const nextHash = `#${path}`;

  if (replace) {
    window.location.replace(`${window.location.pathname}${window.location.search}${nextHash}`);
    return;
  }

  window.location.hash = path;
}

export function reloadTo(path: AppRoutePath) {
  const nextUrl = `${window.location.pathname}${window.location.search}#${path}`;
  if (window.history?.pushState) {
    window.history.pushState(null, '', nextUrl);
  } else {
    window.location.hash = path;
  }
  window.location.reload();
}

export function useHashPath() {
  const [path, setPath] = useState<AppRoutePath>(getHashPath());

  useEffect(() => {
    const handleHashChange = () => {
      setPath(getHashPath());
    };

    window.addEventListener('hashchange', handleHashChange);
    handleHashChange();

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  return path;
}
